var map = {
	"./assets/Ellipse 957.png": 5481,
	"./assets/Ellipse 958.png": 3566,
	"./assets/Ellipse 959.png": 7207,
	"./assets/Ellipse 960.png": 135,
	"./assets/SCREENCLASS SOLUTIONS.zip": 6853,
	"./assets/SCREENCLASS SOLUTIONS/https_/lottiefiles.com/animations/delete-RgJTzXWDsF.png": 5153,
	"./assets/Screenshot 2022-08-26 155932 1.png": 7994,
	"./assets/ageer.zip": 6397,
	"./assets/ageer2.zip": 6231,
	"./assets/ageer2/Ageer-PersonalUse.otf": 1096,
	"./assets/ageer2/Readme LIcense.txt": 1874,
	"./assets/appstore.png": 2520,
	"./assets/background.png": 9528,
	"./assets/bg-1.1.png": 9276,
	"./assets/bg-1.png": 7295,
	"./assets/bg-2.png": 3732,
	"./assets/brand.png": 2285,
	"./assets/candidate.png": 8641,
	"./assets/circle-questionmark.png": 7372,
	"./assets/dashboard.png": 6318,
	"./assets/delete-RgJTzXWDsF.png": 1439,
	"./assets/edit.png": 6700,
	"./assets/image.png": 8369,
	"./assets/login_screen.png": 9230,
	"./assets/login_screen_1.png": 9882,
	"./assets/login_screen_2.png": 7313,
	"./assets/login_screen_3.png": 9832,
	"./assets/logout.png": 9134,
	"./assets/medal.png": 1435,
	"./assets/oshey.png": 8038,
	"./assets/party_popper.png": 6005,
	"./assets/playstore.png": 7691,
	"./assets/question-mark.zip": 1859,
	"./assets/question-mark/ic_outline-quiz-1.png": 9948,
	"./assets/question-mark/ic_outline-quiz.png": 1670,
	"./assets/question-mark/ic_outline-quiz@2x.png": 6926,
	"./assets/question-mark/ic_outline-quiz@3x.png": 6057,
	"./assets/question_mark.png": 978,
	"./assets/questions.png": 1033,
	"./assets/results.png": 2704,
	"./assets/screen-dark 2.png": 3877,
	"./assets/screen_logo.png": 312,
	"./assets/subjects.png": 307,
	"./assets/successful.png": 4254,
	"./assets/thumbs up.png": 3576,
	"./assets/traffic-age.png": 6319,
	"./assets/users.png": 2358,
	"./components/ManageQuestion/ManageQuestion": 1569,
	"./components/ManageQuestion/ManageQuestion.jsx": 1569,
	"./components/Table/dashboard": 1262,
	"./components/Table/dashboard.jsx": 1262,
	"./components/Table/leaderboard": 3351,
	"./components/Table/leaderboard.jsx": 3351,
	"./components/Table/table": 1398,
	"./components/Table/table.jsx": 1398,
	"./components/brand/brand": 5766,
	"./components/brand/brand.jsx": 5766,
	"./components/button/Buttondelete": 5637,
	"./components/button/Buttondelete.jsx": 5637,
	"./components/button/EditDeleteBtn": 3361,
	"./components/button/EditDeleteBtn.jsx": 3361,
	"./components/button/addbutton": 2395,
	"./components/button/addbutton.jsx": 2395,
	"./components/button/button": 3717,
	"./components/button/button.jsx": 3717,
	"./components/button/loading.css": 2333,
	"./components/card/card": 6320,
	"./components/card/card.jsx": 6320,
	"./components/card/cardThree": 8886,
	"./components/card/cardThree.jsx": 8886,
	"./components/card/cardTwo": 7176,
	"./components/card/cardTwo.jsx": 7176,
	"./components/corrected/corrected": 5554,
	"./components/corrected/corrected.jsx": 5554,
	"./components/createTest/TestQuestion": 1620,
	"./components/createTest/TestQuestion.jsx": 1620,
	"./components/modal-container/loader.css": 8885,
	"./components/modal-container/modal-container": 4434,
	"./components/modal-container/modal-container.jsx": 4434,
	"./components/modal/addModal": 5769,
	"./components/modal/addModal.jsx": 5769,
	"./components/modal/delete": 6440,
	"./components/modal/delete.jsx": 6440,
	"./components/modal/modal": 7542,
	"./components/modal/modal.jsx": 7542,
	"./components/modal/selectModal": 2638,
	"./components/modal/selectModal.jsx": 2638,
	"./components/modal/success": 9768,
	"./components/modal/success.jsx": 9768,
	"./components/pagination/Pagination": 4356,
	"./components/pagination/Pagination.jsx": 4356,
	"./components/pagination/squarePagination": 6769,
	"./components/pagination/squarePagination.jsx": 6769,
	"./components/selectField/selectField": 3926,
	"./components/selectField/selectField.jsx": 3926,
	"./components/sidebar/sidebar": 5014,
	"./components/sidebar/sidebar.jsx": 5014,
	"./components/testscored/testscored": 144,
	"./components/testscored/testscored.jsx": 144,
	"./components/timespent/timespent": 3714,
	"./components/timespent/timespent.jsx": 3714,
	"./components/title/title": 4950,
	"./components/title/title.jsx": 4950,
	"./components/visitedanswer/visitedanswer": 7790,
	"./components/visitedanswer/visitedanswer.jsx": 7790,
	"./components/vistedquestion/visitedquestion": 9029,
	"./components/vistedquestion/visitedquestion.jsx": 9029,
	"./data/Config": 1155,
	"./data/Config.js": 1155,
	"./data/Context": 3135,
	"./data/Context.jsx": 3135,
	"./data/Reducers": 6795,
	"./data/Reducers/": 6795,
	"./data/Reducers/CandidatesReducer": 7641,
	"./data/Reducers/CandidatesReducer.js": 7641,
	"./data/Reducers/ErrorReducer": 309,
	"./data/Reducers/ErrorReducer.js": 309,
	"./data/Reducers/ExamReducer": 6054,
	"./data/Reducers/ExamReducer.js": 6054,
	"./data/Reducers/ExamTypeReducer": 8830,
	"./data/Reducers/ExamTypeReducer.js": 8830,
	"./data/Reducers/GradeReducer": 7562,
	"./data/Reducers/GradeReducer.js": 7562,
	"./data/Reducers/LeaderboardReducer": 1802,
	"./data/Reducers/LeaderboardReducer.js": 1802,
	"./data/Reducers/ResultReducer": 3552,
	"./data/Reducers/ResultReducer.js": 3552,
	"./data/Reducers/SubjectReducer": 3059,
	"./data/Reducers/SubjectReducer.js": 3059,
	"./data/Reducers/UserReducer": 3830,
	"./data/Reducers/UserReducer.js": 3830,
	"./data/Reducers/YearReducer": 4520,
	"./data/Reducers/YearReducer.js": 4520,
	"./data/Reducers/index": 6795,
	"./data/Reducers/index.js": 6795,
	"./data/Store": 5432,
	"./data/Store.js": 5432,
	"./pages/": 6357,
	"./pages/admin": 7437,
	"./pages/admin/": 7437,
	"./pages/admin/[id]": 1588,
	"./pages/admin/[id].jsx": 1588,
	"./pages/admin/index": 7437,
	"./pages/admin/index.jsx": 7437,
	"./pages/dashboard": 9320,
	"./pages/dashboard/": 9320,
	"./pages/dashboard/index": 9320,
	"./pages/dashboard/index.jsx": 9320,
	"./pages/index": 6357,
	"./pages/index.jsx": 6357,
	"./pages/leaderboard": 373,
	"./pages/leaderboard/": 373,
	"./pages/leaderboard/index": 373,
	"./pages/leaderboard/index.jsx": 373,
	"./pages/manage": 9597,
	"./pages/manage-exams": 7842,
	"./pages/manage-exams/": 7842,
	"./pages/manage-exams/edit": 5600,
	"./pages/manage-exams/edit.jsx": 5600,
	"./pages/manage-exams/index": 7842,
	"./pages/manage-exams/index.jsx": 7842,
	"./pages/manage-exams/question": 3176,
	"./pages/manage-exams/question.jsx": 3176,
	"./pages/manage-exams/subjects": 7663,
	"./pages/manage-exams/subjects.jsx": 7663,
	"./pages/manage-grade": 2663,
	"./pages/manage-grade/": 2663,
	"./pages/manage-grade/index": 2663,
	"./pages/manage-grade/index.jsx": 2663,
	"./pages/manage-subjects": 2681,
	"./pages/manage-subjects/": 2681,
	"./pages/manage-subjects/[id]": 5120,
	"./pages/manage-subjects/[id].jsx": 5120,
	"./pages/manage-subjects/index": 2681,
	"./pages/manage-subjects/index.jsx": 2681,
	"./pages/manage-year": 6329,
	"./pages/manage-year/": 6329,
	"./pages/manage-year/index": 6329,
	"./pages/manage-year/index.jsx": 6329,
	"./pages/manage/": 9597,
	"./pages/manage/index": 9597,
	"./pages/manage/index.jsx": 9597,
	"./pages/test": 8925,
	"./pages/test.jsx": 8925,
	"./pages/users": 1252,
	"./pages/users/": 1252,
	"./pages/users/index": 1252,
	"./pages/users/index.jsx": 1252,
	"./pages/view-results": 4446,
	"./pages/view-results/": 4446,
	"./pages/view-results/index": 4446,
	"./pages/view-results/index.jsx": 4446,
	"./pages/view-results/result": 655,
	"./pages/view-results/result.jsx": 655,
	"./screens/home": 2129,
	"./screens/home.jsx": 2129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6729;